import {
  BoxLoading,
  Container,
  Header,
  Body,
  Filters,
  DataInfor,
  Menu,
  Search,
  Paginate,
  PaginateInfor,
  PaginateNav,
  Options,
  OptionFilter,
} from "./styled";
import { AiOutlineSearch, AiOutlineLoading } from "react-icons/ai";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useState } from "react";
import ConfirmationDelete from "../../../../components/Modal-Confirmation";
import { useHistory } from "react-router-dom";
import Card from "../../components/Card";
import { translations } from "../../../../utils/language";
import Modal from "../../components/Modal";
import { set } from "date-fns";

const Home = () => {
  const [search, setSearch] = useState("");
  const [perPage, setPerPage] = useState(20);
  const [page, setPage] = useState(1);

  const users = useSelector((state) => state.reducerAdminList);
  const dispatch = useDispatch();
  const history = useHistory();
  const language = useSelector((state) => state.reducerLanguage);
  const expire = useSelector((state) => state.reducerAdminExpire);

  const [inativeFilter, setInativeFilter] = useState(false);
  const [integrationFilter, setIntegrationFilter] = useState(false);
  const [shopifyFilter, setShopifyFilter] = useState(false);
  const [nuvemshopFilter, setNuvemshopFilter] = useState(false);
  const [dropiFilter, setDropiFilter] = useState(false);
  const [hotmartFilter, setHotmartFilter] = useState(false);
  const [siteFilter, setSiteFilter] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [date, setDate] = useState();
  const [userId, setUserId] = useState();
  const [isIntegration, setIsIntegration] = useState(false);
  const [isNuvem, setIsNuvem] = useState(false);

  useEffect(() => {
    if (isIntegration) {
      if (localStorage.getItem("depoimentosAdmin@login")) {
        dispatch({
          type: "SAGA_GET_INTEGRATIONS",
          payload: {
            page: page,
            filter: "Nuvemshop",
          },
        });
      } else {
        history.push("/");
      }
    }
  }, [
    perPage,
    page,
    integrationFilter,
    shopifyFilter,
    nuvemshopFilter,
    hotmartFilter,
    siteFilter,
    dropiFilter,
    history,
    dispatch,
    inativeFilter,
    expire,
    isIntegration,
  ]);

  useEffect(() => {
    if (isNuvem) {
      if (localStorage.getItem("depoimentosAdmin@login")) {
        dispatch({
          type: "SAGA_GET_INTEGRATIONS_NUVEM",
          payload: {
            page: page,
            filter: "Nuvemshop",
          },
        });
      } else {
        history.push("/");
      }
    }
  }, [
    perPage,
    page,
    integrationFilter,
    shopifyFilter,
    nuvemshopFilter,
    hotmartFilter,
    siteFilter,
    dropiFilter,
    history,
    dispatch,
    inativeFilter,
    expire,
    isNuvem,
  ]);

  const statusDeleteCard = useSelector((state) => state.reducerAdminDeleteCard);
  useEffect(() => {
    if (
      !statusDeleteCard.loading &&
      !statusDeleteCard.error &&
      !isIntegration &&
      statusDeleteCard.data.length == 0
    ) {
    } else {
      if (
        !statusDeleteCard.loading &&
        !statusDeleteCard.error &&
        !isIntegration
      ) {
        dispatch({
          type: "SAGA_LIST_ADMIN",
          payload: {
            search: "",
            perPage: 20,
            page: 1,
            isIntegrated: integrationFilter,
            platforms: `${shopifyFilter && "shopify,"}${
              nuvemshopFilter && "nuvemshop,"
            }${hotmartFilter && "hotmart,"}${siteFilter && "custom,"}${
              dropiFilter && "dropi,"
            }`,
            isDesactived: inativeFilter,
          },
        });
      }
    }
  }, [statusDeleteCard, isIntegration]);

  const goSearch = () => {
    dispatch({
      type: "SAGA_LIST_ADMIN",
      payload: {
        search: search.trim(),
        perPage: perPage,
        page: page,
        isIntegrated: integrationFilter,
        platforms: `${shopifyFilter ? "shopify," : ""}${
          nuvemshopFilter ? "nuvemshop," : ""
        }${hotmartFilter ? "hotmart," : ""}${siteFilter ? "custom," : ""}${
          dropiFilter ? "dropi," : ""
        }`,
        isDesactived: inativeFilter,
      },
    });
  };

  useEffect(() => {
    if (!isNuvem) {
      goSearch();
    }
  }, [isNuvem]);



  const countItens = () => {
    let result = 0;
    if (page == users.data?.meta?.last_page) result = users.data?.meta?.total;
    else result = page * perPage;
    return result;
  };

  return (
    <>
      {modalVisible && (
        <Modal
          closeModal={() => setModalVisible(false)}
          date={date}
          userId={userId}
        />
      )}
      <Container>
        <Header>
          <Menu>
            <label>Inicio</label>
            <label
              onClick={() => {
                localStorage.removeItem("depoimentosAdmin@login");
                localStorage.removeItem("depoimentos@login");
                history.push("/login");
              }}
            >
              {translations["Sair"][language.data]}
            </label>
          </Menu>
        </Header>
        <Body>
          <Filters>
            <Search>
              <input
                type={"text"}
                placeholder={"Pesquisar..."}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
              <span
                onClick={() => {
                  setPage(1);
                  goSearch();
                }}
              >
                <AiOutlineSearch size={25} color={"gray"} />
              </span>
            </Search>
            <Options>
              <OptionFilter
                onClick={() => {
                  setIsNuvem(false);
                }}
                active={isNuvem === false && isIntegration === false}
              >
                Usuários
              </OptionFilter>
              {/* <OptionFilter
                onClick={() => {
                  setIsIntegration(true) && setIsNuvem(false);
                }}
                active={isNuvem === false && isIntegration === true}
              >
                Integração
              </OptionFilter> */}
              <OptionFilter
                onClick={() => setIsNuvem(true)}
                active={isNuvem === true}
              >
                Nuvemshop
              </OptionFilter>
            </Options>
          </Filters>
          {users.loading ? (
            <BoxLoading>
              <span>
                <AiOutlineLoading size={30} color={"#20d489"} />
              </span>
            </BoxLoading>
          ) : isNuvem ? (
            <>
              <DataInfor>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Loja [chave empreender]</th>
                    <th>Whatsapp</th>
                    <th>Criação</th>
                    <th>Vencimento</th>
                    <th>E-mail</th>
                    <th>Cartão</th>
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {users?.dataIntegration?.data?.map((item) => {
                    return (
                      <Card
                        item={item}
                        openModal={() => {
                          setModalVisible(true);
                          setDate(item.cred_expire);
                          setUserId(item.id);
                        }}
                      />
                    );
                  })}
                </tbody>
              </DataInfor>
              {/* <Paginate>
                  <PaginateNav>
                    <span
                      onClick={() => {
                        if (page != 1) setPage(page - 1);
                      }}
                    >
                      <MdKeyboardArrowLeft
                        size={35}
                        color={
                          users.data?.meta?.current_page == 1
                            ? "gray"
                            : "#19B674"
                        }
                      />
                    </span>
                    <label>{users.data?.meta?.current_page}</label>
                    <span
                      onClick={() => {
                        if (page < users.data?.meta?.last_page)
                          setPage(page + 1);
                      }}
                    >
                      <MdKeyboardArrowRight
                        size={35}
                        color={
                          users.data?.meta?.last_page == page
                            ? "gray"
                            : "#19B674"
                        }
                      />
                    </span>
                  </PaginateNav>
                  <PaginateInfor>
                    <label>
                      Total {countItens()} - {users.data?.meta?.total}
                    </label>
                  </PaginateInfor>
                </Paginate> */}
            </>
          ) : (
            <>
              <DataInfor>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Loja [chave empreender]</th>
                    <th>Whatsapp</th>
                    <th>Criação</th>
                    <th>Vencimento</th>
                    <th>E-mail</th>
                    <th>Cartão</th>
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {users?.data?.data?.map((item) => {
                    return (
                      <Card
                        item={item}
                        openModal={() => {
                          setModalVisible(true);
                          setDate(item.cred_expire);
                          setUserId(item.id);
                        }}
                      />
                    );
                  })}
                </tbody>
              </DataInfor>
              <Paginate>
                <PaginateNav>
                  <span
                    onClick={() => {
                      if (page != 1) setPage(page - 1);
                    }}
                  >
                    <MdKeyboardArrowLeft
                      size={35}
                      color={
                        users.data?.meta?.current_page == 1 ? "gray" : "#19B674"
                      }
                    />
                  </span>
                  <label>{users.data?.meta?.current_page}</label>
                  <span
                    onClick={() => {
                      if (page < users.data?.meta?.last_page) setPage(page + 1);
                    }}
                  >
                    <MdKeyboardArrowRight
                      size={35}
                      color={
                        users.data?.meta?.last_page == page ? "gray" : "#19B674"
                      }
                    />
                  </span>
                </PaginateNav>
                <PaginateInfor>
                  <label>
                    Total {countItens()} - {users.data?.meta?.total}
                  </label>
                </PaginateInfor>
              </Paginate>
            </>
          )}
          {/* {isNuvem === false ? (
            users.loading ? (
              <BoxLoading>
                <span>
                  <AiOutlineLoading size={30} color={"#20d489"} />
                </span>
              </BoxLoading>
            ) : (
              <>
                <DataInfor>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Loja [chave empreender]</th>
                      <th>Whatsapp</th>
                      <th>Criação</th>
                      <th>Vencimento</th>
                      <th>E-mail</th>
                      <th>Cartão</th>
                      <th>Opções</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users?.data?.data?.map((item) => {
                      return (
                        <Card
                          item={item}
                          openModal={() => {
                            setModalVisible(true);
                            setDate(item.cred_expire);
                            setUserId(item.id);
                          }}
                        />
                      );
                    })}
                  </tbody>
                </DataInfor>
                <Paginate>
                  <PaginateNav>
                    <span
                      onClick={() => {
                        if (page != 1) setPage(page - 1);
                      }}
                    >
                      <MdKeyboardArrowLeft
                        size={35}
                        color={
                          users.data?.meta?.current_page == 1
                            ? "gray"
                            : "#19B674"
                        }
                      />
                    </span>
                    <label>{users.data?.meta?.current_page}</label>
                    <span
                      onClick={() => {
                        if (page < users.data?.meta?.last_page)
                          setPage(page + 1);
                      }}
                    >
                      <MdKeyboardArrowRight
                        size={35}
                        color={
                          users.data?.meta?.last_page == page
                            ? "gray"
                            : "#19B674"
                        }
                      />
                    </span>
                  </PaginateNav>
                  <PaginateInfor>
                    <label>
                      Total {countItens()} - {users.data?.meta?.total}
                    </label>
                  </PaginateInfor>
                </Paginate>
              </>
            )
          ) : (
            <></>
          )} */}
        </Body>
      </Container>
    </>
  );
};

export default Home;
